import type { LimitationValue } from "src/shared/api-types/limitations";

import type { LimitationFormValues } from "./types";

export type LimitationTemplate = Pick<LimitationFormValues, "code" | "name" | "type" | "operator" | "unit"> & {
  key: string;
  values: LimitationValue[];
};

export const limitationTemplates: LimitationTemplate[] = [
  {
    key: "wind",
    code: "WIND",
    name: "Wind",
    type: "number",
    operator: "<",
    unit: "kt",
    values: [20, 25, 30],
  },
  {
    key: "gusts",
    code: "GUSTS",
    name: "Gusts",
    type: "number",
    operator: "<",
    unit: "kt",
    values: [10, 15, 20],
  },
  {
    key: "ceiling",
    code: "CEILING",
    name: "Ceiling",
    type: "number",
    operator: ">",
    unit: "ft",
    values: [800, 1000, 1500, 2000],
  },
  {
    key: "visibility",
    code: "VISIBILITY",
    name: "Visibility",
    type: "number",
    operator: ">",
    unit: "km",
    values: [3, 5, 8, 10],
  },
  {
    key: "pax",
    code: "PAX",
    name: "Pax",
    type: "list",
    operator: null,
    unit: "",
    values: ["VFR only", "Max"],
  },
  {
    key: "performance",
    code: "PERFORMANCE",
    name: "Performance",
    type: "list",
    operator: null,
    unit: "",
    values: ["HOGE", "HIGE", "Limited"],
  },
  {
    key: "night_operations",
    code: "NIGHT_OPERATIONS",
    name: "Night Operations",
    type: "boolean",
    operator: null,
    unit: "",
    values: [true],
  },
  {
    key: "custom",
    code: "CUSTOM",
    name: "",
    type: "number",
    operator: "<",
    unit: "",
    values: [],
  },
];

export const getTemplateByKey = (key: string): LimitationTemplate | undefined =>
  limitationTemplates.find((template) => template.key === key);
